import React from "react";
import classes from "./LevelsPage.module.css";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetIndex } from "../slices/activeTileSlice";
import { resetTiles } from "../slices/tileWordSlice";
import { resetEnteredWords } from "../slices/enteredWordSlice";
import { resetTargetWord } from "../slices/targetWordSlice";
import { resetTargetWord3 } from "../slices/targetWord3Slice";
import { resetWord3Result } from "../slices/word3Result";
import { resetWordResult } from "../slices/wordResult";
import Button from "../components/newComponents/Button";
import BottomNavbar from "../components/newComponents/BottomNavbar";
import { ResetTime, ResetTimeForProgress } from "../slices/timeSlice";

const LevelsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    dispatch(resetIndex());
    dispatch(resetTiles());
    dispatch(resetEnteredWords());
    dispatch(resetTargetWord());
    dispatch(resetTargetWord3());
    dispatch(resetWord3Result());
    dispatch(resetWordResult());
    dispatch(ResetTime());
    dispatch(ResetTimeForProgress());
    navigate(path);
  };
  return (
    <Layout>
      <Card>
        <CardHeader title="Levels" />
        <div className={classes.levels_container}>
          <Button
            text="Easy Mode"
            onPress={() => navigateHandler("/easy-mode")}
          />
          <Button
            text="Medium Mode"
            onPress={() => navigateHandler("/medium-mode")}
          />
          <Button
            text="Hard Mode"
            onPress={() => navigateHandler("/hard-mode")}
          />
        </div>
        <div className={classes.divider}></div>
        <CardHeader title="Categories" style={{ padding: 0 }} />
        <div className={classes.categories_container}>
          <Button
            style={{ width: "120px" }}
            text="Animals"
            onPress={() => navigateHandler("/category/animal")}
          />
          <Button
            style={{ width: "120px" }}
            text="Sports"
            onPress={() => navigateHandler("/category/sport")}
          />
          <Button
            style={{ width: "120px" }}
            text="Human Body"
            onPress={() => navigateHandler("/category/human body")}
          />
          <Button
            style={{ width: "120px" }}
            text="Food"
            onPress={() => navigateHandler("/category/food")}
          />
        </div>
      </Card>
      <BottomNavbar active={2} />
    </Layout>
  );
};

export default LevelsPage;
